<template>
  <div class="page-wrapper">
    <div class="container-fluid pt-0 mt-2">
      <loading
        :active.sync="isLoading"
        :is-full-page="fullPage"
        background-color="#f3f3f3"
        :opacity="0.8"
        loader="bars"
      ></loading>

      <EditDriverDetails
        v-if="editDriverModal"
        :driver="editedDrivers"
        :show="editDriverModal"
        v-on:closeEditDriverModal="editDriverModal = false"
        @showSuccessPopup="handleSuccessPopup"
      />

      <SuccessModal
        :show="showSuccessPopup"
        @close="showSuccessPopup = false"
        :msg="successMsg"
        :heading="successHeading"
        msgWidth="msg_width_driverDeets"
      />

      <ChangeVehicle
        v-if="changeVehicleModal"
        :vehicle="changedVehicle"
        :driverid="selectedDriverId"
        :show="changeVehicleModal"
        v-on:closeChangeVehicleModal="changeVehicleModal = false"
        @showSuccessPopup="handleSuccessPopup"
      />

      <DeleteModal
        :show="showDelete"
        @submit="handleAction('delete')"
        @close="closeDelete"
        :action="$t('deactivate')"
        :name="$t('driver')"
        :msg="$t('deactivate_msg')"
      />

      <ConfirmModal
        :msg="$t('activate_driver_text')"
        :show="showConfirm"
        @close="showConfirm = false"
        @submit="handleAction('confirm')"
        :heading="$t('activate_driver')"
        :btnTxt="$t('yes_activate')"
        is-yellow
        msgWidth="msg_width"
      />

      <div>
        <p style="font-size: 14px; font-weight: 700;">
          {{ $t("driver-profile") }}
        </p>

        <div class="row card_row">
          <div class="available_container">
            <div class="card_content">
              <div
                class="img_div"
                style="background-color: rgba(222, 234, 242, 1);"
              >
                <img src="../../assets/images/truck1.svg" />
              </div>
              <div class="card_text">
                <span class="title">{{
                  driverSummary.available ? $t("available") : $t("unavailable")
                }}</span>
                <span class="info">{{ $t("status") }}</span>
              </div>
            </div>
            <div class="status" :class="{ inactive: !driverSummary.available }">
              <p>
                {{ driverSummary.available ? $t("active") : $t("inactive") }}
              </p>
            </div>
          </div>

          <div>
            <div class="card_content">
              <div
                class="img_div"
                style="background-color: rgba(143, 205, 159, 0.3);"
              >
                <img src="../../assets/images/truck1.svg" />
              </div>
              <div class="card_text">
                <span class="title"> {{ driverSummary.completedTrips }}</span>
                <span class="info"> {{ $t("completed-trips") }} </span>
              </div>
            </div>
          </div>

          <div>
            <div class="card_content">
              <div
                class="img_div"
                style="background-color: rgba(243, 201, 99, 0.3);"
              >
                <img src="../../assets/images/clock.svg" />
              </div>
              <div class="card_text">
                <span class="title">{{ driverSummary.totalTimeSpent }}</span>
                <span class="info"> {{ $t("time-spent") }} </span>
              </div>
            </div>
          </div>
        </div>

        <div
          class="largecardWrapper"
          style="height: fit-content; margin-top: 1.5rem"
        >
          <div class="driver_details">
            <div class="driver mb-4">
              <h4>{{ $t("driver_details") }}</h4>
              <div class="driver_info">
                <div class="info">
                  <p class="info_text">{{ $t("name") }}</p>
                  <p class="info_deets">{{ driverDetails.name }}</p>
                </div>

                <div class="info">
                  <p class="info_text">{{ $t("phone_num") }}</p>
                  <p class="info_deets">{{ driverDetails.phoneNumber }}</p>
                </div>

                <div class="info">
                  <p class="info_text">{{ $t("emailModal.emailAddress") }}</p>
                  <p class="info_deets">{{ driverDetails.email }}</p>
                </div>

                <div class="info">
                  <p class="info_text">{{ $t("address") }}</p>
                  <p class="info_deets">{{ driverDetails.address }}</p>
                </div>

                <div class="actions click">
                  <span
                    @click="editdriver(driverDetails)"
                    style="color: rgba(33, 62, 122, 1);"
                  >
                    {{ $t("edit-details") }}
                  </span>
                  <span style="color: rgba(33, 62, 122, 1);"> | </span>
                  <span
                    @click="handleClick"
                    :style="{
                      color: driverSummary.available
                        ? 'rgba(235, 87, 87, 1)'
                        : 'rgba(33, 62, 122, 1)',
                    }"
                  >
                    {{
                      driverSummary.available
                        ? $t("deactivate-driver")
                        : $t("activate-driver")
                    }}
                  </span>
                </div>
              </div>
            </div>

            <div class="vehicle">
              <h4>{{ $t("vehicle_assigned") }}</h4>
              <div class="driver_info">
                <div class="info">
                  <p class="info_text">{{ $t("name") }}</p>
                  <p class="info_deets">
                    {{
                      driverDetails.assignedVehicleData
                        ? driverDetails.assignedVehicleData.name
                        : "N/A"
                    }}
                  </p>
                </div>

                <div class="info">
                  <p class="info_text">{{ $t("plate_number") }}</p>
                  <p class="info_deets">
                    {{
                      driverDetails.assignedVehicleData
                        ? driverDetails.assignedVehicleData.plateNumber
                        : "N/A"
                    }}
                  </p>
                </div>

                <div class="info">
                  <p class="info_text">{{ $t("type") }}</p>
                  <p class="info_deets" style="text-transform: capitalize;">
                    {{
                      driverDetails.assignedVehicleData
                        ? driverDetails.assignedVehicleData.type
                        : "N/A"
                    }}
                  </p>
                </div>

                <div class="actions">
                  <span
                    class="click"
                    @click.stop="editvehicle(driverDetails.assignedVehicleData)"
                    style="color: rgba(33, 62, 122, 1);"
                  >
                    {{ $t("change-vehicle") }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="trips" style="overflow-x: auto">
            <div
              class="header d-flex justify-content-between align-items-center"
            >
              <h4>{{ $t("trips") }}</h4>

              <TableSearch @handleSearch="handleSearch" />
            </div>

            <div>
              <div>
                <div ref="content" class="table-responsive">
                  <table id="order-listing" class="table table-hover display">
                    <thead style="background-color: rgba(240, 244, 251, 0.6)">
                      <tr>
                        <th
                          :key="index"
                          v-for="(column, index) in tableColumns"
                          @click="sortBy(column[1])"
                          style="cursor: pointer; text-align: left"
                        >
                          {{ column[0] }}
                          <span
                            class="arrow"
                            :class="sortOrders[column[1]] > 0 ? 'asc' : 'dsc'"
                          ></span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(driverOrder, index) in paginatedData"
                        :key="index"
                        class="user-row"
                        style="border-bottom: unset"
                        :class="{
                          'data-table-bg': index % 2 !== 0,
                        }"
                      >
                        <td>{{ formatDate(driverOrder.startedAt) }}</td>
                        <td>#{{ driverOrder.orderReference}}</td>

                        <td>{{ driverOrder.totalTimeSpent }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <Pagination
                  :pageCount="pageCount"
                  :data="paginatedData"
                  :sizeperpage="sizeperpage"
                  :pageNumber="pageNumber"
                  :pages="pages"
                  @goToLastPage="goToLastPage"
                  @nextPage="nextPage"
                  @handlePageChange="handlePageChange"
                  @goToFirstPage="goToFirstPage"
                  @prevPage="prevPage"
                  @onchange="onchange"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import "intro.js/introjs.css";

import Pagination from "../../components/PaginationNew.vue";
import tableMixin from "../../mixins/tableMixinWithBackend";
import TableSearch from "../../components/TableSearch.vue";

import EditDriverDetails from "../Modals/EditDriverDetails";
import SuccessModal from "../Modals/SuccessModal.vue";

import ChangeVehicle from "../../views/Modals/ChangeVehicle.vue";
import DeleteModal from "../Modals/DeleteModal.vue";

import ConfirmModal from "../../views/Modals/ConfirmModal.vue";

import moment from "moment";

export default {
  name: "DriverDetailsPage",
  mixins: [tableMixin],

  props: {
    id: {
      type: String,
      required: true,
    },
  },
  components: {
    Loading,
    TableSearch,
    Pagination,
    EditDriverDetails,
    SuccessModal,
    ChangeVehicle,
    DeleteModal,
    ConfirmModal,
  },
  data() {
    return {
      isLoading: true,
      fullPage: true,
      dataTable: [],
      editDriverModal: false,
      editedDrivers: [],
      changedVehicle: [],
      selectedDriverId: this.id,
      successMsg: "",
      successHeading: "",
      showSuccessPopup: false,
      changeVehicleModal: false,
      showDelete: false,
      showConfirm: false,
      sortOrders: {},
    };
  },
  computed: {
    ...mapGetters([
      "drivers",
      "driverDetails",
      "driverSummary",
      "driverOrder",
      "meta",
    ]),
    paginationMeta() {
      return this.meta;
    },
    tableColumns() {
      return [
        [this.$t("trip-date"), "trip-date"],
        [this.$t("order-id"), "order-id"],
        [this.$t("time-spent"), "time-spent"],
      ];
    },
  },
  methods: {
    ...mapActions([
      "getDriverDetails",
      "getDriverDetailsSummary",
      "getDriverDetailsOrder",
      "deactivateDriver",
    ]),
    formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY hh:mmA") : "-";
    },
    handleAction(actionType) {
      this.isLoading = true;

      const deactivateDriver = {
        enabled: !this.driverSummary.available,
      };

      this.deactivateDriver({
        deactivateDriver,
        driverId: this.id,
      }).then(() => {
        this.getDriverDetailsSummary(this.id);

        if (actionType === "confirm") {
          this.showConfirm = false;
        } else if (actionType === "delete") {
          this.showDelete = false;
        }

        this.showSuccessPopup = true;
        if (!this.driverSummary.available) {
          this.successMsg = this.$t("activated_driver_mssg");
          this.successHeading = this.$t("activated_driver_heading");
        } else {
          this.successMsg = this.$t("deactivated_driver_mssg");
          this.successHeading = this.$t("deactivated_driver_heading");
        }
        this.isLoading = false;
      });
    },
    handleClick() {
      if (this.driverSummary.available) {
        this.openDelete();
      } else {
        this.showConfirm = true;
      }
    },
    openDelete() {
      this.showDelete = true;
    },
    closeDelete() {
      this.showDelete = false;
    },

    handleSuccessPopup({ msg, heading }) {
      this.successMsg = msg;
      this.successHeading = heading;
      this.showSuccessPopup = true;
    },
    editdriver(DriverInfo) {
      this.editedDrivers = [DriverInfo];
      this.Tag = "";

      this.editDriverModal = true;
    },
    editvehicle(DriverInfo) {
      this.changedVehicle = [DriverInfo];

      this.changeVehicleModal = true;
    },
    doSearch() {
      let params = {
        ...this.params,
        keyword: this.searchQuery,
      };

      this.fetchDriverDetailsOrder(this.id, params);
    },

    fetchDriverDetailsOrder(driverId, params) {
      this.isLoading = true;
      return this.getDriverDetailsOrder({ driverId, params }).finally(() => {
        this.isLoading = false;
      });
    },

    fetchDrivers(driverId) {
      this.isLoading = true;

      Promise.all([
        this.getDriverDetails(driverId),
        this.getDriverDetailsSummary(driverId),
        this.fetchDriverDetailsOrder(driverId, this.params),
      ]).catch((error) => {
        this.isLoading = false;
      });
    },
  },
  mounted() {
    const driverId = this.id;
    if (driverId) {
      this.fetchDrivers(driverId);
    } else {
      console.error("Driver ID is missing");
    }
  },
  watch: {
    driverOrder: {
      handler: function() {
        this.dataTable = this.driverOrder;
      },
      deep: true,
    },
    params() {
      this.fetchDriverDetailsOrder(this.id, this.params); // Use the centralized method
    },
  },
};
</script>

<style scoped>
.header {
  margin-bottom: 1rem;
}

.img_div {
  width: 60.79px;
  height: 60px;
  gap: 0px;
  border-radius: 100%;
  opacity: 0.5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card_row {
  display: flex;
  gap: 2rem;
  margin: 0 auto;
}

.card_row > div {
  display: flex;
  padding: 2.5rem 2rem 2.5rem;
  border-radius: 10px;
  width: 370px;
  gap: 0.5rem;
  background-color: rgba(255, 255, 255, 1);
}

.available_container {
  display: flex;
  justify-content: space-between;
}

.card_content {
  display: flex;
  height: 49px;
  align-items: center;
  gap: 0.7rem;
}

.card_text {
  display: flex;
  flex-direction: column;
  gap: 5px;
  height: 49px;
  justify-items: center;
}

.card_text > .title {
  font-size: 22px;
  font-weight: 800;
  text-align: left;
}

.card_text > .info {
  font-size: 14px;
  font-weight: 400;
}

.status {
  display: flex;
  align-items: center;
  font-weight: 500;
  size: 14px;
  height: 20px;
  padding: 20px 8px 10px;
  border-radius: 24px;
  color: rgba(0, 165, 81, 1);
  background-color: rgba(206, 246, 217, 1);
}

.status.inactive {
  color: rgb(244, 95, 95); /* Adjust this color as needed */
  background-color: rgb(254, 190, 190);
}

.largecardWrapper {
  position: relative;
  display: grid;
  grid-template-columns: 3fr 7fr;
  gap: 1rem;
  min-width: 0;
  word-wrap: break-word;
  background-clip: border-box;
}

.driver,
.vehicle,
.trips {
  background-color: #fff;
  border-radius: 16px;
  padding: 1rem;
}

.driver_info > .info {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgba(225, 231, 236, 1);
  font-size: 14px;
}

.driver_info {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.actions {
  font-size: 14px;
  font-weight: 500;
}

.info_text {
  font-weight: 400;
  color: rgba(134, 147, 165, 1);
}

.info_deets {
  font-weight: 600;
}

.click {
  cursor: pointer;
}

@media (max-width: 576px) {
  .card_row > div {
    width: 95%;
    margin: 0 auto;
  }
}

@media (min-width: 576px) and (max-width: 767px) {
  .card_row {
    flex-wrap: wrap;
    gap: 0.6rem;
  }
  .card_row > div {
    width: 250px;
    padding: 2.5rem 1rem 2.5rem;
  }
}

@media (min-width: 768px) and (max-width: 911px) {
  .card_row > div {
    width: 330px;
  }
}

@media (min-width: 912px) and (max-width: 991px) {
  .card_row > div {
    width: 260px;
    padding: 2.5rem 1rem 2.5rem;
  }
}

@media (max-width: 1024px) {
  .largecardWrapper {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
  }
}

@media (min-width: 1024px) and (max-width: 1279px) {
  .card_row > div {
    width: 330px;
  }
}

@media (min-width: 1280px) and (max-width: 1410px) {
  .card_row > div {
    width: 310px;
  }
}
</style>
